<template>
  <div class="form-group">
    <div class="grey mb5">{{ label ?? name }}</div>
    <div class="field-with-icon">
      <date-picker :name="name" :placeholder="placeholder" v-validate="rules" v-model="inputValue" :disabled="disabled"
        :config="options.date"></date-picker>
      <div class="icon-form">
        <span class="icon-ico-date"></span>
      </div>
    </div>
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldTextInput',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.value,
      options: {
        date: {
          format: 'DD-MM-YYYY'
        }
      },
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator']
};
</script>
